// Generated by GitHub Copilot

/**
 * Apply a theme mode to the document and persist it.
 *
 * @param {"light" | "dark" | "system"} theme Theme mode.
 */
export function setTheme(theme) {
  if (!theme) {
    return;
  }

  document.documentElement.setAttribute("data-theme", theme);

  try {
    localStorage.setItem("theme", theme);
  } catch (_error) {
    // Ignore storage errors in restricted contexts.
  }
}

/**
 * Read current theme preference from storage.
 *
 * @returns {"light" | "dark" | "system"} Saved mode or dark fallback.
 */
export function getTheme() {
  try {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme === "light" || storedTheme === "dark" || storedTheme === "system") {
      return storedTheme;
    }
  } catch (_error) {
    // Ignore storage errors in restricted contexts.
  }

  return "dark";
}

/**
 * Attach click listeners for optional non-React toggle controls.
 *
 * @param {HTMLButtonElement | null} buttonLight Light mode button.
 * @param {HTMLButtonElement | null} buttonDark Dark mode button.
 * @param {HTMLButtonElement | null} buttonSystem System mode button.
 */
export function wireThemeToggle(buttonLight, buttonDark, buttonSystem) {
  if (buttonLight) {
    buttonLight.addEventListener("click", function onLightClick() {
      setTheme("light");
    });
  }

  if (buttonDark) {
    buttonDark.addEventListener("click", function onDarkClick() {
      setTheme("dark");
    });
  }

  if (buttonSystem) {
    buttonSystem.addEventListener("click", function onSystemClick() {
      setTheme("system");
    });
  }
}
